import { applicationModuleRegistry } from '../application-module-registry.js';
import { findRouteById, getRoutes, normalizeRoutes } from './routes.js';
function isModuleGroup(module) {
    if (!module) {
        return false;
    }
    return Object.prototype.hasOwnProperty.call(module, 'modules');
}
async function getModules() {
    // @ts-expect-error
    const { get } = await import('virtual:oswald-modules');
    return await get();
}
async function registerModules(modules) {
    const routes = await getRoutes();
    normalizeRoutes(routes, '/');
    for (const module of modules) {
        if (isModuleGroup(module)) {
            const applicationModuleGroup = prepareApplicationModuleGroup(routes, module);
            applicationModuleRegistry.registerGroup(applicationModuleGroup);
        }
        else {
            const applicationModule = prepareApplicationModule(routes, module);
            applicationModuleRegistry.register(applicationModule);
        }
    }
}
function getApplicationModuleRoutes(route, mainRoute) {
    const routes = [];
    for (const child of route.children ?? []) {
        const moduleRoute = {
            main: mainRoute.id === child.id,
            name: child.name,
            route: child.path,
        };
        if (Array.isArray(child.children)) {
            moduleRoute.children = getApplicationModuleRoutes(child, mainRoute);
        }
        routes.push(moduleRoute);
    }
    return routes;
}
function prepareApplicationModule(routes, module) {
    const moduleRoute = findRouteById(routes, module.routeId);
    const mainModuleRoute = findRouteById(routes, module.mainRouteId);
    if (!moduleRoute) {
        throw new Error(`[bootstrap/modules]: Could not create a route for module "${module.id}"`);
    }
    const applicationModule = {
        closeable: module.closeable,
        disabled: module.disabled,
        entry: module.entry,
        hidden: module.hidden,
        icon: module.icon,
        id: module.id,
        name: module.name,
        order: module.order,
        route: moduleRoute.path,
    };
    if (mainModuleRoute) {
        applicationModule.routes = getApplicationModuleRoutes(moduleRoute, mainModuleRoute);
    }
    return applicationModule;
}
function prepareApplicationModuleGroup(routes, moduleGroup) {
    const modules = [];
    for (const module of moduleGroup.modules ?? []) {
        modules.push(prepareApplicationModule(routes, module));
    }
    const { entry, id, name, order } = moduleGroup;
    return {
        entry,
        id,
        modules,
        name,
        order,
    };
}
export { getModules, isModuleGroup, registerModules, };
//# sourceMappingURL=modules.js.map